import '@shoelace-style/shoelace/dist/themes/light.css';
import '@shoelace-style/shoelace/dist/components/select/select';
import '@shoelace-style/shoelace/dist/components/option/option';

class Select {
  constructor() {
    this.selectEl = document.querySelectorAll('[data-dispatcher-select]');

    this.redirect = this.redirect.bind(this);
    this.addEventListeners();
  }

  addEventListeners() {
    this.selectEl.forEach(el => el.addEventListener('sl-change', this.redirect));
  }

  redirect(evt) {
    // Make sure event is fired from current select
    if (evt.target.localName === 'sl-select') {
      const url = new URL(evt.target.value, window.location.origin);
      const target = encodeURI(url.pathname);
      window.location.assign(target);
    }
  }
}
export default new Select();
